// Follows "HR Design rules.md": GEN, DIS
import * as React from 'react';

import { cn } from '@/lib/utils';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  height?: string;
}

/** Multi-line text field (design system `textarea`): same border, focus, disabled and read-only tokens as Input. */
const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, height, style, ...props }, ref) => (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-16 w-full rounded-md border border-input bg-card px-2.5 py-1.5 text-base shadow-sm transition-[color,border-color,box-shadow] duration-fast ease-standard outline-none placeholder:text-muted-foreground md:text-sm',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'disabled:cursor-not-allowed disabled:border-disabled-border disabled:bg-disabled disabled:text-disabled-foreground disabled:shadow-none disabled:placeholder:text-disabled-foreground',
        '[&:read-only:not(:disabled)]:bg-readonly',
        'aria-invalid:border-destructive aria-invalid:focus-visible:ring-destructive',
        className
      )}
      ref={ref}
      style={height ? { ...style, height } : style}
      {...props}
    />
  )
);
Textarea.displayName = 'Textarea';

export { Textarea };
